// ============================================================================
// UKRAINIAN TRANSLATIONS - BIBLE VERSES
// ============================================================================
// Колекція натхненних віршів з посиланнями на Стронга

export const bibleVerses = [
  {
    reference: "Филип'ян 4:13",
    text: "Все можу в Христі, що мене підкріплює",
    version: "Переклад Івана Огієнка",
    theme: "сила",
    strongNumbers: {
      "можу": "G1411", // δύναμις (dynamis) = сила, міць
      "підкріплює": "G1743" // ἐνδυναμόω (endynamoo) = зміцнювати
    },
    context: "Павло говорить про свою здатність справлятися з усіма ситуаціями через Христа"
  },
  {
    reference: "Псалом 23:1",
    text: "Господь мій Пастир, нічого мені не бракне",
    version: "Переклад Івана Огієнка",
    theme: "захист",
    strongNumbers: {
      "Пастир": "H7462", // רָעָה (ra'ah) = пасти, дбати
      "бракне": "H2637" // חָסֵר (chaser) = бракувати, потребувати
    },
    context: "Давид виражає свою повну довіру до Божого провидіння"
  },
  {
    reference: "Івана 3:16",
    text: "Бо так Бог полюбив світ, що дав Сина Свого Єдинородного",
    version: "Переклад Івана Огієнка",
    theme: "любов",
    strongNumbers: {
      "полюбив": "G25", // ἀγαπάω (agapao) = любити безумовно
      "дав": "G1325" // δίδωμι (didomi) = давати, віддавати
    },
    context: "Найвідоміший вірш про Божу любов до людства"
  },
  {
    reference: "Филип'ян 4:7",
    text: "І мир Божий, що перевищує всякий розум, охоронятиме серця ваші",
    version: "Переклад Івана Огієнка",
    theme: "мир",
    strongNumbers: {
      "мир": "G1515", // εἰρήνη (eirene) = мир, гармонія
      "охоронятиме": "G5432" // φρουρέω (phroureo) = охороняти, захищати
    },
    context: "Обітниця Божого захисту через внутрішній мир"
  },
  {
    reference: "Псалом 119:105",
    text: "Слово Твоє - то світильник для ніг моїх і світло для стежки моєї",
    version: "Переклад Івана Огієнка",
    theme: "керівництво",
    strongNumbers: {
      "світильник": "H5216", // נִיר (niyr) = світильник, світило
      "світло": "H216" // אוֹר (or) = світло, освітлення
    },
    context: "Боже Слово як провідник у повсякденному житті"
  },
  {
    reference: "Приповісті 3:5-6",
    text: "Надійся на Господа всім серцем своїм, і не спирайся на свій розум",
    version: "Переклад Івана Огієнка",
    theme: "довіра",
    strongNumbers: {
      "Надійся": "H982", // בָּטַח (batach) = довіряти
      "серцем": "H3820" // לֵב (leb) = серце, розум, воля
    },
    context: "Заклик довіряти Богові, а не власним здібностям"
  },
  {
    reference: "Матвія 5:14",
    text: "Ви - світло світу. Не може сховатися місто, що стоїть на верху гори",
    version: "Переклад Івана Огієнка",
    theme: "свідчення",
    strongNumbers: {
      "світло": "G5457", // φῶς (phos) = світло, духовне освітлення
      "світу": "G2889" // κόσμος (kosmos) = світ, всесвіт
    },
    context: "Ісус закликає своїх учнів бути свідками у світі"
  }
];

export default bibleVerses;
